<template>
  <div class='collection'>
    <div class="c-wrapper">
      <div class="c-left">
        <div class="c-money-warpper">
          <div class="c-money" v-if="couponItem.coupon_type === 4">
            <span class="c-text">{{couponItem.discount_amount / 100}}</span>
            <span class="c-icon">折</span>
          </div>
          <div class="c-money" v-else>
            <span class="c-icon">¥</span>
            <span class="c-text">{{couponItem.discount_amount / 100}}</span>
          </div>
          <div class="c-limit">
            {{condition_value}}
          </div>
        </div>
        <div class="c-term-wrapper">
          <div class="c-title">{{couponItem.coupon_name}}</div>
          <div class="c-text-wrapper">
            <div class="c-text-item">
              {{couponItem.effective_days}}
            </div>
            <div class="c-text-item">
              {{couponItem.coupon_use_type_name}}
            </div>
          </div>
        </div>
      </div>
      <div class="c-right">
        <div class="c-btn-warpper">
          <!-- <div>立</div>
          <div>即</div>
          <div>领</div>
          <div>取</div> -->
        </div>
      </div>
    </div>
  </div>

</template>

<script type="span/ecmascript-6">
export default {
  name: 'Coupon',
  props: {
    couponItem: {
      type: Object,
      default: () => { },
    },
  },
  data () {
    return {
      condition_value: '', // 使用条件
    }
  },
  methods: {
    formatDate: (timestamp) => {
      if (typeof timestamp === 'number') {
        let time = new Date(timestamp * 1000)
        return `${time.getFullYear()}.${time.getMonth() + 1}.${time.getDate()}`
      }
      return timestamp
    },
  },
  mounted () {
    if (this.couponItem.coupon_type === 4) {
      this.condition_value = `满${this.couponItem.condition_value / 100}元可用`
    } else if (this.couponItem.coupon_type === 1 || this.couponItem.coupon_type === 3) {
      if (this.couponItem.condition_value === 0) {
        this.condition_value = '不限制'
      } else {
        this.condition_value = `满${this.couponItem.condition_value / 100}减${this.couponItem.discount_amount / 100}`
      }
    } else if (this.couponItem.coupon_type === 2) {
      this.condition_value = '不限制'
    }
  },
}
</script>

<style scoped lang="stylus">
.collection
  .c-wrapper
    display flex
    justify-content center
    margin-bottom 20px
    height 112px
    background url('~@/assets/template/coupon-bg.png') no-repeat center center / 100% 100%
    .c-left
      position relative
      display flex
      padding 25px 15px 20px 35px
      width 284px
      font-size 12px
      border-top-left-radius 5px
      border-bottom-left-radius 5px
      color #EBC89E
      // background linear-gradient(140deg, rgba(58, 56, 66, 1) 0%, rgba(27, 26, 31, 1) 100%)
      // &::before, &::after
      // content ''
      // width 10px
      // height 10px
      // border 1px solid #F6F0E8
      // position absolute
      // right -5px
      // border-radius 50%
      // background #F6F0E8
      // z-index 1
      // &::before
      // top -5px
      // &::after
      // bottom -5px
      .c-money-warpper
        display flex
        flex-direction column
        justify-content space-between
        width 95px
        color #DD1D21
        .c-money
          display flex
        .c-text
          line-height 1
          font-size 35px
          font-weight bold
        .c-limit
          color #404040
      .c-term-wrapper
        padding 0 12px
        display flex
        flex-direction column
        justify-content space-between
        .c-title
          color #404040
        .c-text-wrapper
          color #7F7F7F
          .c-text-item
            position relative
            padding-left 10px
            line-height 18px
            &::before
              content ''
              width 4px
              height 4px
              background #B29778
              position absolute
              left 0
              bottom 50%
              margin-bottom -2px
    .c-right
      display flex
      justify-content center
      width 61px
      font-size 14px
      border-top-right-radius 5px
      border-bottom-right-radius 5px
      color #1B1A1F
      // background #E8C18E
      .c-btn-warpper
        display flex
        flex-direction column
        justify-content center
        align-items center
</style>



// WEBPACK FOOTER //
// src/components/content/modal/Coupon.vue